import { Button, Grid, TextField } from "@mui/material";
import GlobalDialogContent from "../GlobalDialogContent";
import { useFormik } from "formik";
import * as Yup from "yup";

const BookEvent = () => {
    const formik = useFormik({
        initialValues: {
            fname: "",
            lname: "",
            contact: "",
            email: "",
        },
        validationSchema: Yup.object({
            fname: Yup.string().required("First Name is Required"),
            lname: Yup.string().required("Last Name is Required"),
            contact: Yup.string().matches(/^\d{10}$/, "Contact must be a 10-digit number").required("Mobile Number is Required"),
            email: Yup.string().email("Invalid email format").required("Email is Required"),
        }),
        onSubmit: (values) => {
            
        },
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <GlobalDialogContent
                dialogBody={
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                size="small"
                                margin="normal"
                                label="First Name *"
                                name="fname"
                                value={formik.values.fname}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.fname && Boolean(formik.errors.fname)}
                                helperText={formik.touched.fname && formik.errors.fname}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                size="small"
                                margin="normal"
                                label="Last Name *"
                                name="lname"
                                value={formik.values.lname}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.lname && Boolean(formik.errors.lname)}
                                helperText={formik.touched.lname && formik.errors.lname}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                size="small"
                                margin="normal"
                                label="Mobile Number *"
                                name="contact"
                                type="text"
                                value={formik.values.contact}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.contact && Boolean(formik.errors.contact)}
                                helperText={formik.touched.contact && formik.errors.contact}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                size="small"
                                margin="normal"
                                label="Email *"
                                name="email"
                                type="email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                            />
                        </Grid>                   
                    </Grid>
                }
                dialogFooter={
                    <>
                        <>
                            <Button type="submit" variant="contained" color="success">
                                Submit
                            </Button>
                        </>
                    </>
                }
            />
        </form>
    );
};

export default BookEvent;
